<template>
  <v-container grid-list-lg fluid>
    <v-layout row wrap>
      <v-flex xs12>
        <v-card class="elevation-3">
          <v-card-text>
            <v-layout justify-center align-center>
              <v-flex xs12>
                <pivot
                  fields-label-text="Columnas activos"
                  columns-label-text="Totales activos"
                  available-colums-label-text="Totales disponibles"
                  available-fields-label-text="Columnas disponibles"
                  :data="data"
                  :filters="filters"
                  :fields-list="lists.fieldsList"
                  :columns-list="lists.columnsList"
                  :default-columns="defaultColumns"
                  @loading="clearData"
                  @loaded="setData">
                  <filters-bar
                    title="Gestiones"
                    title-class="headline"
                    :filters="filters"
                    :has-channel="true"
                    :has-all-channels="true"
                    :custom-filters="customFilters"
                    @search="applyFilters">
                    <template slot="content">
                      <v-flex md2>
                        <v-btn
                          class="h-100 ma-0 w-100 btn-filter"
                          @click="generateReport">
                          <v-icon small>fas fa-download</v-icon>
                        </v-btn>
                      </v-flex>
                    </template>
                  </filters-bar>
                </pivot>
              </v-flex>
            </v-layout>
          </v-card-text>
        </v-card>
      </v-flex>
    </v-layout>
  </v-container>
</template>

<script>
import _ from 'lodash';
import moment from 'moment';
import { mapGetters } from 'vuex';
import Pivot from '@/components/global/report_datatables/Pivot';
import FiltersBar from '@/components/global/FiltersBar';

export default {
  components: {
    Pivot,
    FiltersBar,
  },
  data() {
    return {
      dialog: false,
      data: [],
      customFilters: [
        {
          text: 'Estado',
          value: 'status',
        },
        {
          text: 'Tipo gestión',
          value: 'type',
        },
      ],
      filters: {
        type: 1,
        code: 'NS',
        channel: 0,
        date: moment().format('YYYY-MM-DD'),
        dateType: 'date',
      },
      defaultColumns: [
        {
          label: 'Total',
          value: 'total',
        },
      ],
    };
  },
  computed: {
    ...mapGetters([
      'dimentions',
    ]),
    dims() {
      if (this.dimentions.length) {
        return this.dimentions.map((item) => {
          const { title, name } = item;
          const obj = {};
          obj.label = title;
          obj.value = name;
          return obj;
        });
      }
      return [];
    },
    lists() {
      const lists = {
        fieldsList: [
          {
            label: 'Canal',
            value: 'channel',
          },
          {
            label: 'Estado',
            value: 'status',
          },
          {
            label: 'Agencia',
            value: 'agency',
          },
          {
            label: 'Tramo',
            value: 'tranche',
          },
          {
            label: 'Vencimiento',
            value: 'due_day',
          },
          {
            label: 'Portafolio',
            value: 'portfolio_type',
          },
          {
            label: 'Tipo de cuenta',
            value: 'account_type',
          },
          {
            label: 'Agente',
            value: 'agent',
          },
          {
            label: 'Genero',
            value: 'gender',
          },
          {
            label: 'Grupo de edad',
            value: 'age_group',
          },
          {
            label: 'Estado / Región ',
            value: 'state',
          },
          {
            label: 'Estado de contacto',
            value: 'status_type',
          },
          ...this.dims,
        ],
        columnsList: [
          {
            label: 'Monto',
            value: 'amount',
          },
        ],
      };
      lists.fieldsList = _.sortBy(lists.fieldsList, ['label']);
      return lists;
    },
  },
  methods: {
    generateReport() {
      this.$store.commit('SET_DOWNLOAD_CHANNEL', `company.${this.$auth.user().company.id}.${this.$auth.user().id}.download_report`);
      this.$store.dispatch('SEND_DOWNLOAD_REQUEST', {
        route: 'reports',
        params: {
          filters: {
            ...this.filters,
          },
          functionName: 'managementTotal',
        },
      });
    },
    clearData() {
      this.data = [];
      this.isDataLoading = true;
    },
    setData($event) {
      this.data = $event;
      this.isDataLoading = false;
    },
    applyFilters($event) {
      this.filters = {
        ...this.filters,
        ...$event,
      };
    },
  },
};
</script>



// WEBPACK FOOTER //
// src/components/reports/notification_schedules/Index.vue